import React, { memo } from 'react';

const EmptySpace = () => {
    return (
        <section className="empty-space">
        </section>  
    )
}

export default memo(EmptySpace);
